import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import Icons from "views/Icons.js";
import Order from "views/Order.js";
import Step2 from "views/Step2.js";
import Step3 from "views/Step3.js";
import Step4 from "views/Step4.js";
import Typography from "views/Typography.js";
import TableList from "views/Tables.js";
import Maps from "views/Map.js";
import UserPage from "views/User.js";
import UpgradeToPro from "views/Upgrade.js";

import Outlets from "Container/Outlets/Outlets"
import Category from "Container/Category/Category"
import Menu from "Container/Menu/Menu"
import Staff from "Container/Staff/Staff"
import Index from "Container/NewOrder/Index"
import OrderDetails from "Container/Orders/OrderDetails";
import PendingOrders from "Container/Orders/PendingOrders";
import ConfirmOrders from "Container/Orders/ConfirmOrders";
import PreviousOrders from "Container/Orders/PreviousOrders";
import Reports from "Container/Orders/Reports";
import TodaysOrders from "Container/Orders/TodaysOrders";

var routes = [
  {
  path: "/dashboard",
  userType:'staff',
  name: "Dashboard",
  icon: "nc-icon nc-bank",
  component: Dashboard,
  layout: "/portal",
},
/*{
  path: "/order",
  name: "New Order",
  icon: "nc-icon nc-cart-simple",
  component: Step4,
  layout: "/portal",
},
{
  path: "/icons",
  name: "Orders",
  icon: "nc-icon nc-cart-simple",
  component: Icons,
  layout: "/portal",
},*/
{
  path: "/orders",
  userType:'admin',
  name: "New Orders",
  icon: "nc-icon nc-cart-simple",
  component: Index,
  layout: "/portal",
},
{
  path: "/Staff",
  name: "Staff",
  userType:'admin',
  icon: "nc-icon nc-single-02",
  component: Staff,
  layout: "/portal",
},
{
  path: "/Menu",
  name: "Menu",
  userType:'admin',
  icon: "nc-icon nc-single-copy-04",
  component: Menu,
  layout: "/portal",
},
{
  path: "/Category",
  name: "Category",
  userType:'admin',
  icon: "nc-icon nc-bullet-list-67",
  component: Category,
  layout: "/portal",
},
{
  path: "/outlets",
  name: "Outlets",
  userType:'admin',
  icon: "nc-icon nc-shop",
  component: Outlets,
  layout: "/portal",
},
{
  path: "/reports",
  name: "Reports",
  userType:'admin',
  icon: "nc-icon nc-single-copy-04",
  component: Reports,
  layout: "/portal",
},
{
  path: "/previous-order",
  name: "Previous Orders",
  userType:'staff',
  icon: "nc-icon nc-shop",
  component: PreviousOrders,
  layout: "/portal",
},
// {
//   path: "/confirm-order",
//   name: "Confirmed Orders",
//   userType:'staff',
//   icon: "nc-icon nc-shop",
//   component: ConfirmOrders,
//   layout: "/portal",
// },
{
  path: "/pending-orders",
  name: "Pending Orders",
  userType:'staff',
  icon: "nc-icon nc-shop",
  component: PendingOrders,
  layout: "/portal",
},
{
  path: "/todays-orders",
  name: "Todays Orders",
  userType:'staff',
  icon: "nc-icon nc-shop",
  component: TodaysOrders,
  layout: "/portal",
},


];
export default routes;